import api from "@/services/api/packageFolder.js";
import { useState } from "react";

const usePackageFolders = () => {
	const [folders, setFolders] = useState([]);
	const [foldersMeta, setFoldersMeta] = useState({});
	const [currentFolder, setCurrentFolder] = useState([]);
	const [folderLoading, setFolderLoading] = useState(false);
	const [folderErrorMsg, setFolderErrorMsg] = useState("");

	async function fetchAllFolders(params = {}) {
		setFolderLoading(true);

		const [error, response] = await api.getAllFolders(params);

		setFolderLoading(false);

		if (error) {
			return setFolderErrorMsg("Folder API has error");
		}

		const { items, meta } = response;
		setFolders(items);
		setFoldersMeta(meta);
	}

	async function getFolder(id) {
		setFolderLoading(true);

		const [error, response] = await api.getFolder(id);

		setFolderLoading(false);

		if (error) {
			return setFolderErrorMsg("Folder API has error");
		}

		return setCurrentFolder(response);
	}

	return {
		folders,
		foldersMeta,
		currentFolder,
		folderLoading,
		folderErrorMsg,
		fetchAllFolders,
		setCurrentFolder,
		setFolders,
		getFolder,
	};
};

export default usePackageFolders;
